import HttpService from './HttpService';

import * as CONNECTION from '../Constants/Connection';

class DocumentService extends HttpService {
  getNZFAPDocumentsList = async (pageIndex: number) => {
    const getNZFAPDocumentsApiUrl =
      `${CONNECTION.CONTENT}${CONNECTION.API_VERSION}${CONNECTION.RESOURCES}${CONNECTION.NZFAPDOCUMENTSPATH}&pageIndex=${pageIndex}`;

    return super.get(getNZFAPDocumentsApiUrl);
  }
  getSingleDocument = async (docId: string) => {
    const getDocumentApiUrl =
      `${CONNECTION.CONTENT}${CONNECTION.API_VERSION}${CONNECTION.SINGLERESOURCE}${docId}`;
    console.log(getDocumentApiUrl);
    return super.get(getDocumentApiUrl, {}, 'blob');
  }
  
}

export default DocumentService;
